import { FormBase } from 'core/components';
import moment from 'moment';
import validatorjs from 'validatorjs';
import { convertTimeToUTC } from 'core/utils';

export default class ChannelEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'time',
			value => {
				var res = value.split(':');
				var hours = false;
				var minutes = false;
				if (!res[0].includes('H') && res[0] <= 23) {
					hours = true;
					if (!res[1].includes('m') && res[1] <= 59) {
						minutes = true;
					}
				}
				if (hours && minutes) {
					return true;
				}
				return false;
			},
			'INVALIDTIME'
		);

		Validator.register(
			'noFutureDate',
			() => {
				const { lastSyncDate, lastSyncTime } = this.values();
				const inputDateUTC = moment(convertTimeToUTC(`${lastSyncDate} ${lastSyncTime}`));
				const currentDateUTC = moment().utc();
				return inputDateUTC.format('YYYY-MM-DD') <= currentDateUTC.format('YYYY-MM-DD');
			},
			'NOFUTUREDATE'
		);

		Validator.register(
			'noFutureTime',
			() => {
				const { lastSyncDate, lastSyncTime } = this.values();
				const inputDateUTC = moment(convertTimeToUTC(`${lastSyncDate} ${lastSyncTime}`));
				const currentDateUTC = moment().utc();
				if (
					inputDateUTC.utc().format('YYYY-MM-DD') === currentDateUTC.utc().format('YYYY-MM-DD') &&
					inputDateUTC.utc().format('HH:mm') > currentDateUTC.utc().format('HH:mm')
				) {
					return false;
				}

				return true;
			},
			'NOFUTURETIME'
		);
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'CHANNEL.SELLER',
				},
				{
					name: 'name',
					label: 'CHANNEL.NAME',
					rules: 'required|string',
				},
				{
					name: 'timezoneId',
					label: 'CHANNEL.TIMEZONE',
					rules: 'required',
				},
				{
					name: 'channelTypeId',
					label: 'CHANNEL.CHANNELTYPE',
					rules: 'required',
				},
				{
					name: 'carrierChannelIds',
					label: 'CHANNEL.REQUIREDCARRIERS.LABEL',
					placeholder: 'CHANNEL.REQUIREDCARRIERS.PLACEHOLDER',
					rules: 'required',
				},
				{
					name: 'apiKey',
					label: 'CHANNEL.APIKEY',
					rules: 'string',
				},
				{
					name: 'apiSecret',
					label: 'CHANNEL.APISECRET',
					rules: 'string',
				},
				{
					name: 'apiKeyV2',
					label: 'CHANNEL.SHIPSTATIONV2APIKEY',
					rules: 'string',
				},
				{
					name: 'amazonSellerId',
					label: 'CHANNEL.SELLERID',
					rules: 'string',
				},
				{
					name: 'walmartSellerId',
					label: 'CHANNEL.WALMARTSELLERID',
					rules: 'string',
				},
				{
					name: 'walmartAuthorizedOn',
					label: 'CHANNEL.WALMARTAUTHORIZEDON',
					rules: 'string',
				},
				{
					name: 'marketplaceId',
					label: 'CHANNEL.MARKETPLACEID',
					rules: 'string',
				},
				{
					name: 'token',
					label: 'CHANNEL.TOKEN',
					rules: 'string',
				},
				{
					name: 'developerId',
					label: 'CHANNEL.DEVELOPERID',
					rules: 'string',
				},
				{
					name: 'certificateId',
					label: 'CHANNEL.CERTIFICATEID',
					rules: 'string',
				},
				{
					name: 'applicationId',
					label: 'CHANNEL.APPLICATIONID',
					rules: 'string',
				},
				{
					name: 'url',
					label: 'CHANNEL.URL',
					rules: 'string',
				},
				{
					name: 'consumerKey',
					label: 'CHANNEL.CONSUMERKEY',
					rules: 'string',
				},
				{
					name: 'shopId',
					label: 'CHANNEL.SHOPID',
					rules: 'string',
				},
				{
					name: 'consumerSecret',
					label: 'CHANNEL.CONSUMERSECRET',
					rules: 'string',
				},
				{
					name: 'refreshToken',
					label: 'CHANNEL.REFRESHTOKEN',
				},
				{
					name: 'accessToken',
					label: 'CHANNEL.ACCESSTOKEN',
				},
				{
					name: 'partnerId',
					label: 'CHANNEL.PARTNERID',
				},
				{
					name: 'shouldAcknowledgeOrders',
					label: 'CHANNEL.SHOULDACKNOWLEDGE',
					type: 'checkbox',
					value: true,
				},
				{
					name: 'shouldAutoCancel',
					label: 'CHANNEL.SHOULDAUTOCANCEL',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'sellingPartyId',
					label: 'CHANNEL.SELLINGPARTYID',
				},
				{
					name: 'useSandbox',
					label: 'CHANNEL.USESANDBOX',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'checkBuyShippingSunday',
					label: 'CHANNEL.CHECKBUYSHIPPINGSUNDAY',
					type: 'checkbox',
					value: true,
				},
				{
					name: 'useBuyShippingForPrime',
					label: 'CHANNEL.USEBUYSHIPPINGFORPRIME',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'useBuyShippingForNonPrime',
					label: 'CHANNEL.USEBUYSHIPPINGFORNONPRIME',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'useAmazonMli',
					label: 'CHANNEL.USEAMAZONMLI',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'userName',
					label: 'CHANNEL.USERNAME',
				},
				{
					name: 'password',
					label: 'CHANNEL.PASSWORD',
				},
				{
					name: 'channelIds',
					label: 'CHANNEL.CHANNELID',
				},
				{
					name: 'subdomain',
					label: 'CHANNEL.SUBDOMAIN',
				},
				{
					name: 'storeIds',
					label: 'CHANNEL.STOREID',
				},
				{
					name: 'checkSplit',
					label: 'CHANNEL.CHECKSPLIT',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'lastSyncDate',
					label: 'CHANNEL.LASTSYNCDATE',
					rules: 'noFutureDate',
				},
				{
					name: 'lastSyncTime',
					label: 'CHANNEL.LASTSYNCTIME',
					rules: 'noFutureTime',
				},
				{
					name: 'companyIds',
					label: 'CHANNEL.COMPANYIDS',
				},
				{
					name: 'teamName',
					label: 'CHANNEL.TEAMNAME',
				},
				{
					name: 'filterOrdersToPull',
					label: 'CHANNEL.FILTERORDERSTOPULL',
					type: 'checkbox',
				},
				{
					name: 'flagOrderAsImported',
					label: 'CHANNEL.FLAGORDERASIMPORTED',
					type: 'checkbox',
				},
				{
					name: 'flagOrderAsShipped',
					label: 'CHANNEL.FLAGORDERASSHIPPED',
					type: 'checkbox',
				},
				{
					name: 'savedViewId',
					label: 'CHANNEL.SAVEDVIEWID',
				},
				{
					name: 'doNotShipAsap',
					label: 'CHANNEL.DONOTSHIPASAP',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'useAmazonBuyShipping',
					label: 'Use Amazon Buy Shipping',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'useShippingApiV2',
					label: 'Use Amazon Shipping API v2',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'walmartUseSandbox',
					label: 'CHANNEL.WALMARTUSESANDBOX',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'delayLabelPull',
					label: 'CHANNEL.DELAYLABELPULL',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'clientId',
					label: 'CHANNEL.CLIENTID',
					rules: 'string',
				},
				{
					name: 'clientSecret',
					label: 'CHANNEL.CLIENTSECRET',
					rules: 'string',
				},
				{
					name: 'raiseUnlinkedSkuWarning',
					label: 'CHANNEL.RAISEUNLINKEDSKUWARNING',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'shipmentDocumentPullSource',
					label: 'CHANNEL.SHIPMENTDOCUMENTPULLSOURCE',
				},
				{
					name: 'additionalDocumentPullSource',
					label: 'CHANNEL.ADDITIONALDOCUMENTPULLSOURCE',
				},
				{
					name: 'useCustomShipmentTrackingColumn',
					label: 'CHANNEL.USECUSTOMSHIPMENTTRACKINGCOLUMN',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'banyanClientId',
					label: 'CHANNEL.BANYANCLIENTID',
				},
				{
					name: 'banyanClientSecret',
					label: 'CHANNEL.BANYANCLIENTSECRET',
				},
				{
					name: 'logicBrokerExcludeOrderParameters',
					label: 'CHANNEL.LOGICBROKEREXCLUDEORDERPARAMETERS',
				},
				{
					name: 'logicBrokerExcludeOrderParameters[].key',
					label: 'CHANNEL.LOGICBROKEREXCLUDEORDERPARAMETERSKEY',
				},
				{
					name: 'logicBrokerExcludeOrderParameters[].value',
					label: 'CHANNEL.LOGICBROKEREXCLUDEORDERPARAMETERSVALUE',
				},
			],
		};
	}
}
